import angular from 'angular';
import FullscreenService from './FullscreenService';

angular.module('sh.fullscreen', []).service('Fullscreen', FullscreenService);
